<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.12.09</b> - Исправления и улучшения ИИ, производительность Пещеры, и баланс игры.
    </p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        Баланс
        <ul>
          <li>
            - Нерф Адреналин
            <ul>
              <li class="pl-4">
                * стоимость МС: <code>75 - Уровень</code> -->
                <code>150 - Уровень*3</code>
              </li>
              <li class="pl-4">
                * прирост ОД: <code>25 + Уровень*( Си/12 )</code> -->
                <code>10 + Уровень*( Си/12 )</code>
              </li>
            </ul>
          </li>
          <li>
            - Усилена мощность Защитный слой:
            <code>Уровень*1.5</code> --> <code>Уровень*5</code>
          </li>
          <li>
            - Увеличена стоимость ОД Молитва исцеления: <code>20</code> -->
            <code>45</code>
          </li>
          <li>
            - Нерф Убежище
            <ul>
              <li class="pl-4">* стоимость ОД: <code>25</code> --> <code>65</code></li>
              <li class="pl-4">
                * стоимость МС: <code>30 + Уровень*5</code> -->
                <code>40 + Уровень*6</code>
              </li>
              <li class="pl-4">* дальность эффекта: <code>3</code> --> <code>2</code></li>
            </ul>
          </li>
          <li>
            - Нерф Заражение разума
            <ul>
              <li class="pl-4">* стоимость ОД: <code>10</code> --> <code>30</code></li>
              <li class="pl-4">
                * стоимость МС: <code>20 + Уровень*2</code> -->
                <code>20 + Уровень*5</code>
              </li>
            </ul>
          </li>
          <li>
            - Скорректировано масштабирование стоимости МС заклинаний призыва:
            <code>Уровень*50</code> --> <code>100+Уровень*40</code>
          </li>
        </ul>
      </li>
      <li>
        ИИ
        <ul>
          <li>- Герои теперь будут нацеливаться только на героев (не на призываемых)</li>
          <li>
            - Юниты больше не должны выполнять действия до того, как рассчитаны результаты предыдущего
            действия (например, стрельба стрелами по мёртвым врагам).
          </li>
          <li>
            - Юниты больше не должны использовать Roundhouse, когда нет врагов в радиусе.
          </li>
          <li>
            - Изменён способ расчёта "лучшей цели для ближнего боя". Юниты больше не должны
            отрываться от ближайших врагов, чтобы гоняться за дальним врагом с низким ОЗ. Также
            исправляет баг траты хода на бег туда-сюда.
          </li>
          <li>- Юниты больше не должны пропускать ходы с полным ОД</li>
          <li>- Юниты теперь должны стакать Пробивание брони соответствующим образом</li>
          <li>- Юниты теперь должны использовать Добивание на замедленных целях</li>
          <li>- Способности CC больше не должны дублироваться</li>
          <li>
            - Юниты теперь должны использовать Танец стоек соответствующим образом (защитная для танков,
            наступательная для DPS)
          </li>
          <li>
            - Дальний DPS теперь должен использовать разнообразие экипированных способностей (включая
            Дезинфекция и Молния)
          </li>
          <li>- Улучшено нацеливание для способностей DoT</li>
        </ul>
      </li>
      <li>... ииииии ... значительно улучшена производительность CPU Пещеры</li>
    </ul>
  </div>
</template>
